Array.prototype.toDropdownlist = function () {
  return this.map((m) => ({ text: m.name, value: m.id }));
};
